import React, { useState } from 'react';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';

const PropertyListingsTab = () => {
  const [selectedProperty, setSelectedProperty] = useState(null);
  const [filter, setFilter] = useState('all');
  const [searchQuery, setSearchQuery] = useState('');

  const propertyListings = [
    {
      id: 1,
      title: 'Modern 2BHK Apartment',
      owner: 'Amit Sharma',
      propertyType: 'Apartment',
      submissionDate: '2024-10-26',
      status: 'pending',
      location: 'Gurgaon Sector 45',
      price: '₹25,000/month',
      thumbnail: 'https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?w=300&h=200',
      documents: ['Title Deed', 'NOC Certificate', 'Property Tax Receipt'],
      complianceScore: 88,
      flaggedIssues: ['Property tax pending for 2024'],
      area: '1200 sq ft',
      amenities: ['Parking', 'Elevator', 'Security'],
      furnished: 'Semi-Furnished'
    },
    {
      id: 2,
      title: 'Commercial Office Space',
      owner: 'Realty Corp Ltd',
      propertyType: 'Commercial',
      submissionDate: '2024-10-25',
      status: 'under_review',
      location: 'Connaught Place, Delhi',
      price: '₹80,000/month',
      thumbnail: 'https://images.unsplash.com/photo-1497366216548-37526070297c?w=300&h=200',
      documents: ['Commercial License', 'Fire Safety Certificate', 'Building Plan Approval'],
      complianceScore: 94,
      flaggedIssues: [],
      area: '2500 sq ft',
      amenities: ['Central AC', 'Elevator', 'Parking'],
      furnished: 'Unfurnished'
    },
    {
      id: 3,
      title: 'Luxury Villa with Garden',
      owner: 'Dr. Priya Nair',
      propertyType: 'Villa',
      submissionDate: '2024-10-24',
      status: 'approved',
      location: 'Whitefield, Bangalore',
      price: '₹60,000/month',
      thumbnail: 'https://images.unsplash.com/photo-1564013799919-ab600027ffc6?w=300&h=200',
      documents: ['Title Deed', 'Occupancy Certificate', 'Property Insurance'],
      complianceScore: 96,
      flaggedIssues: [],
      area: '3500 sq ft',
      amenities: ['Garden', 'Swimming Pool', 'Security', 'Parking'],
      furnished: 'Fully Furnished'
    }
  ];

  const statusColumns = [
    { id: 'pending', label: 'Pending Review', color: 'yellow' },
    { id: 'under_review', label: 'Under Verification', color: 'blue' },
    { id: 'approved', label: 'Approved', color: 'green' },
    { id: 'rejected', label: 'Rejected', color: 'red' }
  ];

  const filteredProperties = propertyListings?.filter(property => {
    if (filter !== 'all' && property?.status !== filter) return false;
    if (searchQuery && !property?.title?.toLowerCase()?.includes(searchQuery?.toLowerCase()) &&
        !property?.owner?.toLowerCase()?.includes(searchQuery?.toLowerCase())) return false;
    return true;
  });

  const getPropertiesByStatus = (status) => {
    return filteredProperties?.filter(property => property?.status === status);
  };

  const handleApprove = (property) => {
    console.log('Approving property:', property?.id);
  };

  const handleReject = (property) => {
    console.log('Rejecting property:', property?.id);
  };

  return (
    <div className="flex h-full">
      {/* Main Content */}
      <div className={`transition-all duration-300 ${selectedProperty ? 'flex-1' : 'w-full'}`}>
        {/* Filters */}
        <div className="p-6 border-b border-border bg-card">
          <div className="flex flex-col sm:flex-row gap-4">
            <div className="flex-1">
              <Input
                placeholder="Search properties or owners..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e?.target?.value)}
                className="w-full"
              />
            </div>
            <Select
              value={filter}
              onValueChange={setFilter}
              className="w-full sm:w-48"
            >
              <option value="all">All Status</option>
              <option value="pending">Pending</option>
              <option value="under_review">Under Review</option>
              <option value="approved">Approved</option>
              <option value="rejected">Rejected</option>
            </Select>
            <div className="flex gap-2">
              <Button variant="outline" size="sm">
                <Icon name="Filter" size={16} />
              </Button>
              <Button variant="outline" size="sm">
                Bulk Actions
              </Button>
            </div>
          </div>
        </div>

        {/* Kanban Board */}
        <div className="flex-1 p-6 overflow-auto">
          <div className="grid grid-cols-1 lg:grid-cols-4 gap-6 h-full">
            {statusColumns?.map((column) => (
              <div
                key={column?.id}
                className="bg-muted/30 rounded-lg p-4 h-full"
              >
                <div className="flex items-center justify-between mb-4">
                  <h3 className="font-medium text-foreground">{column?.label}</h3>
                  <span className={`px-2 py-1 rounded text-xs font-medium bg-${column?.color}-100 text-${column?.color}-800`}>
                    {getPropertiesByStatus(column?.id)?.length}
                  </span>
                </div>

                <div className="space-y-3">
                  {getPropertiesByStatus(column?.id)?.map((property) => (
                    <div
                      key={property?.id}
                      onClick={() => setSelectedProperty(property)}
                      className="bg-card border border-border rounded-lg p-4 cursor-pointer hover:shadow-md transition-shadow"
                    >
                      <div className="flex items-start gap-3">
                        <img
                          src={property?.thumbnail}
                          alt={property?.title}
                          className="w-12 h-12 rounded object-cover flex-shrink-0"
                        />
                        <div className="flex-1 min-w-0">
                          <h4 className="font-medium text-sm text-foreground truncate">
                            {property?.title}
                          </h4>
                          <p className="text-xs text-muted-foreground truncate">
                            {property?.owner}
                          </p>
                          <div className="flex items-center gap-2 mt-1">
                            <span className="text-xs text-primary font-medium">
                              {property?.propertyType}
                            </span>
                            <span className="text-xs text-muted-foreground">
                              {property?.area}
                            </span>
                          </div>
                        </div>
                      </div>

                      {/* Price and Location */}
                      <div className="mt-3 flex items-center justify-between">
                        <span className="text-sm font-medium text-foreground">
                          {property?.price}
                        </span>
                        <span className="text-xs text-muted-foreground truncate ml-2">
                          {property?.location}
                        </span>
                      </div>

                      {/* Furnished Status */}
                      <div className="mt-2">
                        <span className="inline-block px-2 py-1 bg-blue-50 text-blue-700 text-xs rounded">
                          {property?.furnished}
                        </span>
                      </div>

                      {/* Compliance Score */}
                      <div className="mt-2 flex items-center justify-between">
                        <div className="flex items-center gap-2">
                          <div className={`w-2 h-2 rounded-full ${
                            property?.complianceScore >= 90 ? 'bg-green-500' :
                            property?.complianceScore >= 70 ? 'bg-yellow-500' : 'bg-red-500'
                          }`} />
                          <span className="text-xs text-muted-foreground">
                            {property?.complianceScore}% compliant
                          </span>
                        </div>
                        <span className="text-xs text-muted-foreground">
                          {property?.submissionDate}
                        </span>
                      </div>

                      {/* Quick Actions */}
                      {property?.status === 'pending' && (
                        <div className="mt-3 flex gap-2">
                          <Button
                            size="sm"
                            className="flex-1 h-8 text-xs"
                            onClick={(e) => {
                              e?.stopPropagation();
                              handleApprove(property);
                            }}
                          >
                            <Icon name="Check" size={12} />
                            Approve
                          </Button>
                          <Button
                            variant="outline"
                            size="sm"
                            className="flex-1 h-8 text-xs"
                            onClick={(e) => {
                              e?.stopPropagation();
                              handleReject(property);
                            }}
                          >
                            <Icon name="X" size={12} />
                            Reject
                          </Button>
                        </div>
                      )}

                      {/* Flagged Issues */}
                      {property?.flaggedIssues?.length > 0 && (
                        <div className="mt-2 p-2 bg-red-50 border border-red-200 rounded">
                          <div className="flex items-center gap-1">
                            <Icon name="AlertTriangle" size={12} className="text-red-500" />
                            <span className="text-xs text-red-700">
                              {property?.flaggedIssues?.[0]}
                            </span>
                          </div>
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      {/* Detail Panel */}
      {selectedProperty && (
        <div className="w-96 bg-card border-l border-border p-6 overflow-auto">
          <div className="flex items-center justify-between mb-4">
            <h3 className="font-semibold text-foreground">Property Details</h3>
            <Button
              variant="ghost"
              size="sm"
              onClick={() => setSelectedProperty(null)}
            >
              <Icon name="X" size={16} />
            </Button>
          </div>

          <div className="space-y-6">
            {/* Property Info */}
            <div>
              <img
                src={selectedProperty?.thumbnail}
                alt={selectedProperty?.title}
                className="w-full h-32 object-cover rounded-lg"
              />
              <div className="mt-3">
                <h4 className="font-medium text-foreground">
                  {selectedProperty?.title}
                </h4>
                <p className="text-sm text-muted-foreground">
                  Owner: {selectedProperty?.owner}
                </p>
                <div className="grid grid-cols-2 gap-2 mt-3 text-sm">
                  <div>
                    <span className="text-muted-foreground">Type:</span>
                    <span className="font-medium ml-1">{selectedProperty?.propertyType}</span>
                  </div>
                  <div>
                    <span className="text-muted-foreground">Area:</span>
                    <span className="font-medium ml-1">{selectedProperty?.area}</span>
                  </div>
                  <div>
                    <span className="text-muted-foreground">Furnished:</span>
                    <span className="font-medium ml-1">{selectedProperty?.furnished}</span>
                  </div>
                  <div>
                    <span className="text-muted-foreground">Price:</span>
                    <span className="font-medium ml-1 text-primary">{selectedProperty?.price}</span>
                  </div>
                </div>
                <p className="text-sm text-muted-foreground mt-2">
                  <Icon name="MapPin" size={12} className="inline mr-1" />
                  {selectedProperty?.location}
                </p>
              </div>
            </div>

            {/* Amenities */}
            <div>
              <h5 className="font-medium text-foreground mb-3">Amenities</h5>
              <div className="flex flex-wrap gap-2">
                {selectedProperty?.amenities?.map((amenity, index) => (
                  <span
                    key={index}
                    className="px-2 py-1 bg-green-50 text-green-700 text-xs rounded border border-green-200"
                  >
                    {amenity}
                  </span>
                ))}
              </div>
            </div>

            {/* Document Verification */}
            <div>
              <h5 className="font-medium text-foreground mb-3">Document Verification</h5>
              <div className="space-y-2">
                {selectedProperty?.documents?.map((doc, index) => (
                  <div key={index} className="flex items-center justify-between">
                    <span className="text-sm text-foreground">{doc}</span>
                    <Icon name="CheckCircle" size={16} className="text-green-500" />
                  </div>
                ))}
              </div>
              
              {/* Compliance Score */}
              <div className="mt-4 p-3 bg-muted rounded-lg">
                <div className="flex items-center justify-between">
                  <span className="text-sm font-medium">Compliance Score</span>
                  <span className="text-lg font-bold text-primary">
                    {selectedProperty?.complianceScore}%
                  </span>
                </div>
                <div className="w-full bg-border rounded-full h-2 mt-2">
                  <div
                    className={`h-2 rounded-full ${
                      selectedProperty?.complianceScore >= 90 ? 'bg-green-500' :
                      selectedProperty?.complianceScore >= 70 ? 'bg-yellow-500' : 'bg-red-500'
                    }`}
                    style={{ width: `${selectedProperty?.complianceScore}%` }}
                  />
                </div>
              </div>
            </div>

            {/* Flagged Issues */}
            {selectedProperty?.flaggedIssues?.length > 0 && (
              <div>
                <h5 className="font-medium text-foreground mb-3">Issues to Resolve</h5>
                <div className="space-y-2">
                  {selectedProperty?.flaggedIssues?.map((issue, index) => (
                    <div key={index} className="flex items-start gap-2 p-3 bg-red-50 border border-red-200 rounded">
                      <Icon name="AlertTriangle" size={14} className="text-red-500 mt-0.5 flex-shrink-0" />
                      <span className="text-sm text-red-700">{issue}</span>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {/* Submission History */}
            <div>
              <h5 className="font-medium text-foreground mb-3">Submission History</h5>
              <div className="text-sm text-muted-foreground">
                <div className="flex items-center gap-2 mb-2">
                  <Icon name="Calendar" size={12} />
                  Submitted on {selectedProperty?.submissionDate}
                </div>
                <div className="flex items-center gap-2">
                  <Icon name="User" size={12} />
                  Assigned to Property Verification Team
                </div>
              </div>
            </div>

            {/* Actions */}
            <div className="space-y-3">
              <Button className="w-full">
                <Icon name="Check" size={16} />
                Approve Property
              </Button>
              <Button variant="outline" className="w-full">
                <Icon name="X" size={16} />
                Reject Listing
              </Button>
              <Button variant="outline" className="w-full">
                <Icon name="MessageCircle" size={16} />
                Request Documents
              </Button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PropertyListingsTab;